import axios from "axios";
import store from '../../redux/store';
import AppConsts from "../../appconst";
import * as actions from "./SettingsTypes";
import { UserLogout } from '../Login/LoginActions';
import { Modal } from 'antd';

var logout = false;

export const getSourceList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getSourceList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSOURCELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveSource = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveSource",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteSource = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteSource",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getStageList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getStageList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSTAGELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveStage = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveStage",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteStage = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteStage",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getVerticalList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getVerticalList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETVERTICALLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveVertical = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveVertical",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteVertical = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteVertical",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/saveStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/deleteStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTaskStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTaskStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTASKSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTaskStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTaskStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTaskStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTaskStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getUserRoleList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetUserRoles",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERROLESLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getRoleAuthorizationList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/getRoleAuthorization",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETROLEAUTHORIZATIONLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveRoleAuthorization = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveRoleAuthorization",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const copyRoleAuthorization = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/CopyRoleAuthorization",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const saveRole = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveRole",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const assignRole = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/AssignRole",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getAuthorizedPages = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAuthorizedPages",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETAUTHORIZEDPAGES, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getUserList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetUserList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getAdvanceSeriesList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSeriesList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETADVANCESERIESLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getAdvanceSetting = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAdvanceSetting",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETADVANCESETTING, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const saveAdvanceSetting = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveAdvanceSetting",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getAccountList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetAccountList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETACCOUNTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

// Support Desk
// project
export const getProjectTypeList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetProjectTypeList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETPROJECTTYPELIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveProjectType = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveProjectType",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteProjectType = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectType",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getProjectStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetProjectStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETPROJECTSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveProjectStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveProjectStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteProjectStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteProjectStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const fetchEmbedToken = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: "https://api.powerbi.com/v1.0/myorg/GenerateToken",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

// Ticket

export const getTicketLevelList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketLevelList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETLEVELLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTicketLevel = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketLevel",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketLevel = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketLevel",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTicketPriorityList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketPriorityList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETPRIORITYLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTicketPriority = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketPriority",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketPriority = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketPriority",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getTicketStatusList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTicketStatusList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETTICKETSTATUSLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveTicketStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTicketStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const deleteTicketStatus = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/DeleteTicketStatus",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getDepartmentList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDepartmentList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDEPARTMENTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveDepartment = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveDepartment",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getDeparmentForEdit = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetDepartmentForEdit",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDEPARTMENTDETAIL, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });
    }
};

export const getNotificationList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTktNotify",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETNOTIFICATIONLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveNotification = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTktNotify",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

export const getHistoryList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Settings/GetTktHistory",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETHISTORYLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveHistory = async (data) => {
    try {
        var result = axios({
            method: 'post',
            url: AppConsts.apiBaseUrl + "/Settings/SaveTktHistory",
            data: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err.message };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err.message };
    }
};

